<div class="ade-card">
  <a
    class="ade-card__link"
    [routerLink]="[
      '/',
      activeLang,
      item?.attributes?.availability === 'sold' ? 'vendidos' : 'stock',
      item?.attributes?.slug + '-p' + item?.id,
    ]"
  >
    <div class="ade-card__img-wrap">
      <img
        *ngIf="item?.attributes?.images?.data?.length"
        [src]="getImageUrl(item?.attributes?.images?.data[0], false, 'medium')"
        [alt]="item?.attributes?.name"
        class="ade-card__img"
        loading="lazy"
      />
      <div
        *ngIf="!item?.attributes?.images?.data?.length"
        class="ade-card__img ade-card__img--placeholder"
      ></div>

      <span
        *ngIf="item?.attributes?.availability === 'sold'"
        class="ade-card__badge"
        >VENDIDO</span
      >
      <span
        *ngIf="item?.attributes?.availability === 'restoration'"
        class="ade-card__badge ade-card__badge--restauro"
        >RESTAURO</span
      >
      <span
        *ngIf="item?.attributes?.availability === 'reserved'"
        class="ade-card__badge ade-card__badge--reservado"
        >RESERVADO</span
      >
    </div>

    <div class="ade-card__info">
      <h3 class="ade-card__title">{{ item?.attributes?.name }}</h3>
      <div class="ade-card__meta">
        <span *ngIf="item?.attributes?.year">{{ item.attributes.year }}</span>
        <span
          *ngIf="item?.attributes?.year && item?.attributes?.engine_capacity"
          class="ade-card__sep"
          >|</span
        >
        <span *ngIf="item?.attributes?.engine_capacity"
          >{{ item.attributes.engine_capacity }}CC</span
        >
        <span
          *ngIf="
            showPrices &&
            item?.attributes?.price &&
            (item?.attributes?.year || item?.attributes?.engine_capacity)
          "
          class="ade-card__sep"
          >|</span
        >
        <span *ngIf="showPrices && item?.attributes?.price"
          >€ {{ item.attributes.price | number: "1.0-0" }}</span
        >
      </div>
    </div>
  </a>
</div>
